export default __webpack_public_path__ + "static/media/hessenforst-logo.dd66539d.svg";